angular.module("showcaseApp")
    .directive("bottomUpWrapper", function($window) {
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: 'app/components/bottom-up-wrapper/bottom-up-wrapper.html',
            scope: {
                model: '=?',
                rangeModel: '=',
                buttonText: '=',
                locationButtonText: '@',
                selectedText: '=',
                locationSelectedText: '@',
                headerText: '@',
                onConfirm: '=',
                onClose: '&?',
                onOpen: '&?',
                searchText: '=?',
                spanOption: '@?',
                showMobileTriggerChevron: '<?',
                readOnly: '<?',
                fullscreen: '<',
                onClearSelection: '&',
                type: '=',
                invalid: '<',
                fullHeader: '@',
                inputType: '@?',
                selectAllOption: '<?',
                isFemaleNoun: '<?',
                hideFooter: '<?',
                modalVisible: '=?',
                cancelButtonText: '@?',
                confirmButtonText: '@?',
                hideConfirmButton: '<?',
                hideCancelButton: '<?',
                iconHeader: '@?',
                buttonIcon: '@?',
                hideIcon: '<?',
                uiState: '=?',
                isStoreSelectMode: '<',
                storeTypeId: '<',
                selectedStoreTypeName: '<',
                excludedIds: '<'
            },
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, element, attrs, ctrl) {
                var modal = element.find('.bottom-up-modal');
                if (modal.length) {
                    angular.element(document.body).append(modal);
                    scope.$on('$destroy', function() {
                        modal.remove();
                    });
                }
            },
            controller: function($scope, $translate, systemConstants, $window, toastr, $timeout) {
                var vm = this;

                var inputTypes = ['button', 'field'];
                var defaultInputType = 'button';

                vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;
                vm.hideFooter = vm.hideFooter || false;
                vm.modalVisible = vm.modalVisible || false;
                vm.initialModel = [];
                vm.initialUIState = null;
                vm.cancelButtonText = vm.cancelButtonText || null;
                vm.confirmButtonText = vm.confirmButtonText || null;
                vm.iconHeader = vm.iconHeader || null;
                vm.hideConfirmButton = vm.hideConfirmButton || false;
                vm.hideCancelButton = vm.hideCancelButton || false;

                vm.$onInit = function () {
                    if (!vm.inputType) {
                        vm.inputType = defaultInputType;
                    } else if (!inputTypes.includes(vm.inputType)) {
                        vm.inputType = defaultInputType;
                    }

                    vm.selectAllOption = vm.selectAllOption || false;
                    vm.isFemaleNoun = vm.isFemaleNoun || false;
                };

                vm.getAllSelectedText = function () {
                    return vm.isFemaleNoun ? 'global.form.all-female' : 'global.form.all'
                }

                vm.isIndeterminate = function () {
                    if (angular.isArray(vm.model)) {
                        return vm.model.length > 0 && vm.model.length !== vm.options.length;
                    }
                    return false;
                }

                vm.toggleModal = function () {
                    if (!vm.modalVisible) {
                        vm.initialModel = angular.copy(vm.model);
                        vm.initialUIState = angular.copy(vm.uiState);
                        if (typeof vm.onOpen === 'function') {
                            vm.onOpen();
                        }
                    }
                    vm.modalVisible = !vm.modalVisible;
                };

                vm.closeModal = function () {
                    const min = vm.model;
                    const max = vm.rangeModel;

                    if (vm.type === "range") {
                        if (!min && !max) {
                            vm.modalVisible = false;
                            return;
                        }

                        const isMinDate = min instanceof Date && !isNaN(min);
                        const isMaxDate = max instanceof Date && !isNaN(max);

                        if (!min || (isMinDate && isNaN(min.getTime()))) {
                            toastr.error($translate.instant('flyers.filters.error.empty-min-value'));
                            vm.model = null;
                            vm.rangeModel = null;
                            $('.datetimepicker-input').val('');
                            return;
                        }
                        if (!max || (isMaxDate && isNaN(max.getTime()))) {
                            toastr.error($translate.instant('flyers.filters.error.empty-max-value'));
                            vm.model = null;
                            vm.rangeModel = null;
                            $('.datetimepicker-input').val('');
                            return;
                        }

                        const minValue = isMinDate ? min.getTime() : min;
                        const maxValue = isMaxDate ? max.getTime() : max;

                        if (minValue > maxValue) {
                            toastr.error($translate.instant('flyers.filters.error.invalid-range'));
                            vm.model = null;
                            vm.rangeModel = null;
                            $('.datetimepicker-input').val('');
                            return;
                        }

                        vm.initialModel = angular.copy(vm.model);
                        vm.modalVisible = false;
                    } else {
                        vm.model = angular.copy(vm.initialModel);
                        vm.uiState = angular.copy(vm.initialUIState);
                        vm.modalVisible = false;
                        if (typeof vm.onClose === 'function') {
                            vm.onClose();
                        }
                    }
                    callOnClose();
                };

                vm.confirmSelection = function () {
                    if (angular.isFunction(vm.onConfirm)) {
                        vm.onConfirm();
                    }
                    vm.initialModel = angular.copy(vm.model);
                    vm.initialUIState = angular.copy(vm.uiState);
                    vm.closeModal();
                };

                vm.clearSelection = function ($event) {
                    $event.stopPropagation();

                    if (Array.isArray(vm.model)) {
                        vm.model = [];
                    } else {
                        vm.model = null;
                    }

                    if (vm.rangeModel) {
                        vm.rangeModel = null;
                    }

                    if (typeof vm.onClearSelection === 'function') {
                        vm.onClearSelection();
                    }

                    if (typeof vm.onConfirm === 'function') {
                        $timeout(function () {
                            vm.onConfirm();
                        }, 0);
                    }
                };

                vm.getHeaderTitle = function () {
                    if (vm.type === 'hidden' && vm.fullHeader) {
                        return vm.fullHeader;
                    }
                    if (vm.type === 'location') {
                        if (vm.fullHeader) {
                            return vm.fullHeader;
                        } else {
                            return vm.locationSelectedText ? vm.locationSelectedText.split(' ')[0] : vm.locationButtonText;
                        }
                    } else if (vm.type === 'pagination' || vm.type === 'ordenation') {
                        return vm.headerText ? vm.headerText : vm.selectedText;
                    } else if (vm.type === 'big-size-btn') {
                        return $translate.instant('global.hub.store');
                    } else if (vm.type === 'form-select') {
                        return vm.fullHeader || vm.locationButtonText || '';
                    } else if (vm.type === 'autocomplete-mobile') {
                        return vm.fullHeader || vm.locationButtonText || '';
                    } else {
                        return vm.buttonText || (vm.locationButtonText && vm.locationButtonText.split(' ')[0]);
                    }
                };

                angular.element($window).on('resize', function() {
                    $scope.$apply(function () {
                        vm.isMobile = $window.innerWidth < 768;
                        if (!vm.isMobile) {
                            vm.closeModal();
                        }
                    });
                });

                $scope.$on('$destroy', function () {
                    angular.element($window).off('resize');
                });

                function callOnClose() {
                    if (angular.isFunction(vm.onClose)) {
                        $timeout(function () {
                            vm.onClose();
                        }, 0);
                    }
                }
            }
        };
    });
